// extracted by mini-css-extract-plugin
export default {"root":"BlueBar_root__kZq1S","bluebox":"BlueBar_bluebox__bZVqW","variant2":"BlueBar_variant2__QSkzU","movein":"BlueBar_movein__n6jiI"};